import Vue from 'vue'
import VueResource from 'vue-resource'
import App from './App.vue'
import router from './router'

Vue.use(VueResource);

export const EventBus = new Vue({
  data: {
    menu: {
      'ccd-tipos': 'Tipos de Certificados',
      'ccd-servicos': 'Serviços Disponíveis',
      'ccd-manuais': 'Orientações e Manuais',
      // 'ccd-selo': 'Selo Site Seguro'
      //'ccd-cadeias': 'Cadeias ICP-Brasil'
    },
    ars: null,
    acs: null,
    acordos: null,
    pscs: null,
    nomeAR: ""
  }
});

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js